import { render, staticRenderFns } from "./PanelAccountSettingsWeb.vue?vue&type=template&id=5b17b602&scoped=true&"
import script from "./PanelAccountSettingsWeb.vue?vue&type=script&lang=js&"
export * from "./PanelAccountSettingsWeb.vue?vue&type=script&lang=js&"
import style0 from "./PanelAccountSettingsWeb.vue?vue&type=style&index=0&id=5b17b602&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b17b602",
  null
  
)

export default component.exports